import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { useTranslations } from 'next-intl';

import Copy from '../../../../atoms/copy/copy';
import LongArrowRight from '../../../../icons/longArrowRight.svg';
import RobotIcon from '../../../../icons/robot.svg';
import RadarIcon from '../../../../icons/radar.svg';

import StyledMarker from './marker.style';

import { FloorPlanContext } from '../../floorPlanProvider';

const Marker = ({ entryId, className, entryUrl, title, coordinates, type, variant }) => {
  const t = useTranslations();
  const [isToggled, setIsToogled] = useState(false);
  const { activeMarker, expandedPlan, showWaitingLayer, setWaitingLayerHeadline } =
    useContext(FloorPlanContext);

  const linkHandler = (e, headline) => {
    e.preventDefault();
    setWaitingLayerHeadline(headline);
    showWaitingLayer(type);

    setTimeout(() => {
      window.location = entryUrl;
    }, 5000);
  };

  return (
    <StyledMarker
      id={entryId}
      className={className}
      coordinates={coordinates}
      isToggled={isToggled}
      variant={variant}
      activeMarker={activeMarker && entryId && activeMarker.id === entryId.toString()}
    >
      {type === 'normal' ? (
        <>
          <button
            className="marker__toggle"
            type="button"
            onClick={() => setIsToogled(!isToggled)}
            onKeyPress={e => e.key === 'Enter' && setIsToogled(!isToggled)}
            tabIndex={expandedPlan === variant ? '0' : '-1'}
            aria-label={isToggled ? t('floorPlan.markerClose') : t('floorPlan.markerOpen')}
          >
            {activeMarker && entryId && activeMarker.id === entryId.toString() && <RadarIcon />}
          </button>
          <Copy className="marker__meta">{t('floorPlan.currentLabel')}</Copy>
          {isToggled && (
            <div className="marker__link-wrapper">
              <span className="marker__arrow" />
              <a
                className="marker__link"
                href={entryUrl}
                title={title}
                onClick={e => linkHandler(e, title)}
                onKeyPress={e => e.key === 'Enter' && linkHandler(e, title)}
                tabIndex={expandedPlan === variant ? '0' : '-1'}
              >
                {title}
                <LongArrowRight />
              </a>
            </div>
          )}
        </>
      ) : (
        <a
          className="marker__treasure-link"
          href={entryUrl}
          title={title}
          onClick={e => linkHandler(e, title)}
          onKeyPress={e => e.key === 'Enter' && linkHandler(e, title)}
          tabIndex={expandedPlan === variant ? '0' : '-1'}
        >
          <RobotIcon />
        </a>
      )}
    </StyledMarker>
  );
};

Marker.propTypes = {
  entryId: PropTypes.number.isRequired,
  className: PropTypes.string,
  entryUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  coordinates: PropTypes.shape({ x: PropTypes.number, y: PropTypes.number }).isRequired,
  type: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired
};

export default Marker;
